export const styles = {
  calculationSection: {
    wrapper: "h-full",
    heading: "mb-5 text-black text-[30px] font-semibold font-ssp",
    container: "w-[460px] h-[620px]",
    // container: "border border-gray-200 rounded-md p-8 w-[560px] h-[620px] shadow-xl",

    subSectionWrapper: "-mt-3 ml-[32px] animate-fade duration-0",

    tcsRow: "flex items-center justify-between mt-[18px] relative",
    tcsLeft: "flex items-center text-xs font-normal text-black lg:text-base",
    tcsTooltip: "absolute top-8 bg-white p-2 rounded shadow-lg w-full",
    tcsRight: "flex items-center justify-between space-x-4",
    tcsAmount: "text-xs font-normal text-black lg:text-base",
    currency: "text-xs font-normal text-black lg:text-base",

    nostroToggle: "flex ml-2 cursor-pointer",
    nostroToggleNonPointer: "flex ml-2",
    nostroActive: "rounded px-2 text-white bg-primary-1050",
    nostroInactive: "rounded border px-2 text-black bg-[#E3E3E3]",

    panRow: "flex items-center gap-0 ml-3 mt-2",
    panAdd: "w-fit p-2 flex flex-row items-center justify-center text-primary-1050 font-bold cursor-pointer underline",
    panSelected: "w-fit p-2 flex flex-row items-center justify-center text-primary-1050 font-bold underline cursor-pointer",

    footer: "flex flex-row gap-5 justify-end w-full mt-6",
  },
  reviewOverview: {
    wrapper: "h-full",
    container: "w-[500px] h-[620px]",
  }
}